import { Store } from 'vuex'
import { createStore } from 'vuex-extensions'

import campaigns from './campaigns'
import channelInfluencers from './channel-influencers'
import influencer from './influencer'
import invoices from './invoices'
import links from './links'
import onboarding from './onboarding'
import payment from './payment'
import sales from './sales'
import shop from './shop'
import statistics from './statistics'
import trafficSources from './traffic-sources'
import user from './user'
import userTags from './user-tags'

import { campaign } from '@/legacy/store/campaign'

export default createStore(Store, {
  modules: {
    user,
    shop,
    userTags,
    channelInfluencers,
    links,
    influencer,
    onboarding,
    statistics,
    campaigns,
    invoices,
    sales,
    trafficSources,
    payment,
    campaign,
  },
  actions: {
    async fetchDataWithUpdatedDates({ dispatch }) {
      await dispatch('channelInfluencers/initModule')
      await dispatch('links/initModule')
    },
  },
})
